import React, { useState } from 'react'
import './key-entry.scss'
import Loader from "react-loader-spinner";
import Button from '../../../shared/components/atoms/button/button'
import TitleTab from '../../../shared/components/atoms/title-tab/title-tab'
import { siteUrl } from '../../../shared/utils/siteUrl'

const KeyEntry = props => {

  const { mobile,
    // addKeys,
    getInfoProduct,
    setKeySubmit,
    keySubmit,
    myKeys,
    setMyKeys,
    isLogIn,
    keyLoader,
  } = props;


  const contactRedirect = () => {
    window.location.href = siteUrl + '/contactanos/#entrykey'
  }

  // const [login, setLogin] = useState(false)


  // useEffect(() => {
  //   if (localStorage.getItem('TOKEN_INFO')) {
  //     setLogin(true)
  //   }
  // }, [])
  const [errorKey, seterrorKey] = useState(false)

  const haveErrors = () => {
    if (!(/^[A-Za-z0-9\s]+$/g.test(myKeys))) {
      seterrorKey(true)
    } else {
      seterrorKey(false)
    }

    return (
      !(/^[A-Za-z0-9\s]+$/g.test(myKeys))
    )
  }

  const handleClick = (e) => {
    e.preventDefault();
    if (isLogIn && !haveErrors()) {
      getInfoProduct(myKeys)
    } else if (!isLogIn) {
      sessionStorage.setItem('NEXT_PAGE', window.location.pathname);
      window.location.href = siteUrl + '/login'
    }
  }


  return (
    <div id="keyentry" className="f-key-entry">
      <form className="f-key-entry-container">
        {(mobile && keySubmit.length < 1) && <TitleTab title="Ingreso de claves" className="f-TitleTab f-TitleTab-pink f-TitleTab-pos" />}
        {keySubmit.length < 1 ?
          (
            <>
              <div className="f-key-entry-container-data">
                <p className="f-key-entry-container-data-title">INGRESA TU CLAVE PERSONAL:</p>
                <input
                  type="text"
                  placeholder={"97UL85HMGJD"}
                  value={myKeys.toUpperCase()}
                  disabled={keyLoader ? true : false}
                  onChange={e => { e.stopPropagation(); setMyKeys(e.target.value.slice(0, 10).replace(/ /g, '')); }}
                  className={"f-key-entry-container-data-input" + (errorKey ? " f-input-error" : "")} />
                {errorKey && <label className="f-label-error">*Clave inválida</label>}
                <div>

                  {!mobile ? (
                    <a href="/" onClick={(e) => { e.preventDefault(); contactRedirect() }} className="f-key-entry-container-data-not-find">
                      ¿No encuentras las claves? </a>)
                    : (
                      <span className="f-key-entry-container-data-not-find">
                        Ejemplo: 97UL85HMGJD
                                 </span>
                    )}
                </div>
              </div>
              <div className="f-key-entry-container-submit">
                {keyLoader ? (
                  <div className="f-load-container">
                    <Loader type="TailSpin" color="#FF409B" height={50} width={50} />
                  </div>
                ) : (
                    <div onClick={e => handleClick(e)}>
                      <Button className="primary-pink short" title="Enviar" />
                    </div>
                  )}
              </div>
            </>
          ) : (
            <div className="f-key-entry-response-container">
              <div className="f-key-entry-response-container-info">
                <span className={(keySubmit.status === 200 ? 'icon-check f-icon-res' : '') + (keySubmit.status === 400 ? 'icon-block f-icon-res' : '')} />
                <p className="f-desc-res">{keySubmit.userMessage}</p>
                <a className="f-again-res" onClick={(e) => { e.preventDefault(); setKeySubmit([]) }} href={'/'}>Ingresar otra clave</a>
              </div>
            </div>
          )
        }
      </form>
    </div>
  )
}

export default KeyEntry